module.exports = __webpack_public_path__ + "img/sol_cap5.582775ad.png";